import FramedChalkLayout from '../FramedChalkLayout';

const FramedIvoryLayout = FramedChalkLayout;
export default FramedIvoryLayout;
